<template>
 <v-hover v-slot:default="{ hover }">
     <v-card class='ml-3 mb-3 product' height=300 width=300 :to="{name:'Product',params:{product_id:productId}}">
         <v-img :src="productImage" height=300 width=300>
                <v-expand-transition>
                    <div
                        v-if="hover"
                        class="d-flex transition-fast-in-fast-out black darken-2 v-card--reveal white--text"
                        style="height: 100%;"
                    >
                    <p class='overlay_product_name'>{{productName}}</p>
                
                </div>
                
            </v-expand-transition>
         </v-img>
         
     </v-card>
 </v-hover>
</template>

<style>
.product
{
    cursor:pointer;
}
.overlay_product_name
{
    font-size:28px;
    opacity:1;
}
.v-card--reveal {
  align-items: center;
  bottom: 0;
  justify-content: center;
  opacity: .5;
  position: absolute;
  width: 100%;
}
</style>

<script>
export default {
    name:'Product',
    props:['productImage','productName','productId']
}
</script>